<script setup>
import BaseIcon from "@/app/components/ui/BaseIcon.vue"
import { useConfig } from "@/app/composables/useConfig"
import { t } from "@/app/composables/useI18n"
import { computed, ref } from "vue"
import Casino from "./Casino/index.vue"
import { useBetStore } from "/store.js"

const store = useBetStore()
const { appDivisions } = useConfig()

const tabs = computed(() => {
  return appDivisions.value
    .map(() => {
      return { title: "casino", icon: "casino", value: "casino" }
    })
    .filter(tab => tab && store.getModules.includes(tab.value)) // Filter out null and unsupported tabs
})

const components = {
  casino: Casino,
}

const selectedTab = ref(tabs.value[0]?.value || "")

const isVisibleTabs = computed(() => {
  return tabs.value.length > 1
})
</script>

<template>
  <div>
    <div v-if="isVisibleTabs" class="bets">
      <div
        v-for="(tab, i) in tabs"
        :key="i"
        :class="{ 'active-bet': selectedTab === tab.value }"
        class="bet"
        @click="selectedTab = tab.value"
      >
        <BaseIcon
          :name="tab.icon"
          size="18"
          :color="
            selectedTab === tab.value
              ? 'var(--be-primary-btn-text-label)'
              : 'var(--be-primary-text-color-opacity)'
          "
        />
        <div>
          {{ t(`general.${tab.title}`) }}
        </div>
      </div>
    </div>

    <component :is="components[selectedTab]" />
  </div>
</template>

<style lang="scss" scoped>
.bets {
  display: flex;
  gap: 0 16px;
  justify-content: center;
  border-radius: 10px;
  background: var(--be-big-card-bg);
  padding: 10px;
  margin: 10px 16px;
}

.bet {
  color: rgba(255, 255, 255, 0.3);
  width: 191px;
  height: 40px;
  display: flex;
  gap: 0 8px;
  align-items: center;
  justify-content: center;
  border-radius: 5px;
  font-size: 14px;
  cursor: pointer;
}

.active-bet {
  color: var(--be-primary-btn-label);
  background: var(--be-primary-btn);
}
</style>
